<ng-container *ngIf="items$ | async as items">
  <div *ngIf="items.length" class="container">
    <sd-swiper [items]="items" [config]="defaultConfig">
      <ng-template let-item="item" let-classList="classList">
        <div class="item-wrapper {{ classList }}">
          <ng-container
            [cxComponentWrapper]="{
              flexType: item.typeCode,
              typeCode: item.typeCode,
              uid: item?.uid,
            }"
          ></ng-container>
        </div>
      </ng-template>
    </sd-swiper>
  </div>
</ng-container>
